
import * as type from './types';

export function getMyWorksFiles(data) {
    return {
        type: type.GET_MY_WORKS_FILES_REQUESTED,
        data: data,
    }
};